// Zeffy donation URL builder
// Zeffy doesn't support amount/frequency prefill via URL params, but it
// DOES support UTM params for tracking. We pass the donor's pre-pick as
// UTMs so the client can see in Zeffy / GA which preset+frequency was
// clicked, even though the donor must re-confirm on Zeffy's page.

const ZEFFY_URL =
  process.env.REACT_APP_ZEFFY_URL ||
  "https://www.zeffy.com/en-US/donation-form/play-2-fitness";

/**
 * @param {Object} opts
 * @param {"one_time"|"monthly"} [opts.frequency]
 * @param {number} [opts.amount]
 * @param {string} [opts.source]   utm_content (e.g. "preset_25", "custom", "nav_btn")
 * @param {string} [opts.medium]   utm_medium (default "donate_button")
 */
export function buildZeffyUrl({
  frequency = "one_time",
  amount,
  source,
  medium = "donate_button",
} = {}) {
  const url = new URL(ZEFFY_URL);
  url.searchParams.set("utm_source", "play2fitness_website");
  url.searchParams.set("utm_medium", medium);
  url.searchParams.set("utm_campaign", frequency);
  if (amount) url.searchParams.set("utm_term", `amount_${amount}`);
  if (source) url.searchParams.set("utm_content", source);
  return url.toString();
}

/** Open Zeffy in a new tab. */
export function openZeffy(opts) {
  const href = buildZeffyUrl(opts);
  window.open(href, "_blank", "noopener,noreferrer");
}
